// @flow

import type { ParagraphBlock } from './ParagraphBlock';
import type { ImageBlock } from './ImageBlock';

export const BLOCK_PARAGRAPH_TYPE = 'paragraph';
export const BLOCK_IMAGE_TYPE = 'image';

export type Block = ParagraphBlock | ImageBlock;
